<!DOCTYPE html>
<html lang="en">

<head>
    <title>Sign-up-email</title>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
</head>

<body>
    <div class="limiter">
        <div class="container-login100">
            <div class="wrap-login100">
                <div class="login100-pic js-tilt p-3" data-tilt>
                    <div class="p-4 mt-5">
                        <img src="../../../assets/img/undraw_mailbox_re_dvds.svg" alt="IMG">
                    </div>
                    <div class="text-center mt-5">
                        <small>Já possui uma conta?
                            <a class="btn btn-link" style="text-decoration: none;" href="/login">Entrar</a>
                        </small>
                    </div>
                </div>
                <form class="login100-form validate-form p-5" [formGroup]="formLogin" (ngSubmit)="onSubmit()">
                    <div>
                        <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                            <h4 class="h4-myECD">Informe o e-mail a ser cadastrado</h4>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="form-group col-12">
                            <label class="w-6rem label-login">Email</label>
                            <div class="wrap-input100 validate-input">
                                <input class="input100" pInputText type="text" formControlName="email" />
                                <span class="symbol-input100">
                                    <i class="pi pi-envelope"></i>
                                </span>
                            </div>
                            <div class="mensagemErro mb-3 ml-2" *ngIf="form.email.touched && form.email.invalid">
                                <div class="mensagemErro" *ngIf="form.email.errors.required">
                                    Por favor, informe o e-mail.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <p-button 
                                label="Enviar e-mail" 
                                [disabled]="formLogin.invalid" 
                                [loading]="formLogin.invalid" 
                                class="login100-form-btn p-2">
                            </p-button>
                        </div>
                        
                        <div class="text-center mt-5">
                            <label class="ms-2">
                                <a routerLink="/login">Voltar para tela inicial </a>
                            </label>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</body>

</html>